import React, { Component } from "react";
import { Dialog, DialogActions, DialogContent, Grid, TextField } from "@material-ui/core";
import AppBarModal from "../../general/AppBarModal";
import { BtnForm } from "../../general/BotonesAccion";
import { consulta, mostrarError } from "../../../global/js/funciones";

class RetroalimentacionAdicional extends Component {
  constructor(props) {
    super(props);
    this.state = {
      texto: "",
      cargando: false,
      cargandoGet: false,
    };
  }

  componentDidMount() {
    if (this.props.Modal) {
      this.cargarRetro();
    }
  }

  componentDidUpdate(prevProps) {
    if (!prevProps.Modal && this.props.Modal) {
      this.cargarRetro();
    }
    const prevId = prevProps.estudiante?.identificacion;
    const nextId = this.props.estudiante?.identificacion;
    if (this.props.Modal && prevId !== nextId) {
      this.cargarRetro();
    }
    const prevAct = prevProps.actividad?.id;
    const nextAct = this.props.actividad?.id;
    if (this.props.Modal && prevAct !== nextAct) {
      this.cargarRetro();
    }
  }

  cargarRetro = () => {
    const { actividad, estudiante, actualizarMensaje } = this.props;
    if (!actividad?.id || !estudiante?.identificacion) {
      this.setState({ texto: "", cargandoGet: false });
      return;
    }
    this.setState({ cargandoGet: true });
    consulta(`api/v1.0/sisef/retroalimentacion_adicional/${actividad.id}/${estudiante.identificacion}`, null, null, (error, estado, resp) => {
        if (!error && estado === 204) {
          this.setState({ texto: "", cargandoGet: false });
          return;
        }
        if (!error && estado === 200) {
          this.setState({ texto: resp?.texto || "", cargandoGet: false });
          return;
        }
        if (estado === 204) {
          this.setState({ texto: "", cargandoGet: false });
          return;
        }
        actualizarMensaje({titulo: "No se pudo cargar la retroalimentación.", tipo: "info", mostrar: true, tiempo: 5000});
        this.setState({ cargandoGet: false });
      }
    );
  };

  onChange = ({ target }) => {
    this.setState({ texto: target.value });
  };

  guardar = () => {
    const { texto, cargando } = this.state;
    const { actividad, estudiante, actualizarMensaje, onSuccess, cerrarModal } = this.props;
    if (cargando) return;
    if (!texto || texto.trim().length === 0) {
      actualizarMensaje({titulo: "Debe escribir una retroalimentación.", tipo: "info", mostrar : true, tiempo: 6000});
      return;
    }
    this.setState({ cargando: true });
    const data = {
      actividad: actividad.id,
      estudiante: estudiante.identificacion,
      retroalimentacion: texto.trim(),
    };
    consulta(`api/v1.0/sisef/retroalimentacion_adicional`, data, "POST", (error, estado, resp) => {
        let titulo = "Ha ocurrido un error, contacte con el administrador.";
        let tipo = "error";
        if (!error) {
          if (estado === 200) {
            tipo = "success";
            titulo = resp?.titulo || "Retroalimentación guardada.";
            if (onSuccess) onSuccess();
            cerrarModal(false);
          } else {
            tipo = "info";
            titulo = resp?.titulo ? resp.titulo : mostrarError(resp);
          }
        } else {
          tipo = "info";
          titulo = mostrarError(resp);
        }
        actualizarMensaje({ titulo, tipo, mostrar: true, tiempo: 6000 });
        this.setState({ cargando: false });
      }
    );
  };

  render() {
    const { Modal, cerrarModal, estudiante } = this.props;
    const { texto, cargando, cargandoGet } = this.state;

    return (
      <Dialog fullWidth maxWidth="sm" open={Modal} onClose={() => cerrarModal(false)}>
        <AppBarModal
          titulo={estudiante?.nombre || "Retroalimentación"}
          mostrarModal={() => cerrarModal(false)}
          titulo_accion="Retroalimentación adicional"
          accion=""
        />

        <DialogContent className="scroll">
          <Grid container spacing={2}>
            <Grid item xs={12}>
              <TextField
                label={cargandoGet ? "Cargando..." : "Escribe una retroalimentación adicional"}
                value={texto}
                onChange={this.onChange}
                variant="outlined"
                fullWidth
                multiline
                rows={6}
                disabled={cargando || cargandoGet}
              />
            </Grid>
          </Grid>
        </DialogContent>

        <DialogActions>
          <BtnForm texto="CANCELAR" callback={() => cerrarModal(false)} />
          <BtnForm texto={cargando ? "GUARDANDO..." : "GUARDAR"} callback={this.guardar} />
        </DialogActions>
      </Dialog>
    );
  }
}

export default RetroalimentacionAdicional;
